export default "__VITE_ASSET__84b52b6c__"